export type CreateStepKey =
  | 'personal'
  | 'contact'
  | 'address'
  | 'invoice'
  | 'policies'

export const CREATE_STEPS: CreateStepKey[] = [
  'personal',
  'contact',
  'address',
  'policies',
]

export const CREATE_STEPS_KIDS: CreateStepKey[] = [
  'personal',
  'contact',
  'invoice',
  'policies',
]
